<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2244_54138)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11 17.3C7.52061 17.3 4.7 14.4794 4.7 11C4.7 7.52061 7.52061 4.7 11 4.7C14.4794 4.7 17.3 7.52061 17.3 11C17.3 14.4794 14.4794 17.3 11 17.3ZM3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11ZM11 7.47668C9.05414 7.47668 7.47668 9.05414 7.47668 11C7.47668 12.9459 9.05414 14.5234 11 14.5234C12.9459 14.5234 14.5234 12.9459 14.5234 11C14.5234 9.05414 12.9459 7.47668 11 7.47668Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2244_54138">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
